import React from 'react';
import { motion } from 'framer-motion';
interface Testimonial {
  initials: string;
  name: string;
  location: string;
  quote: string;
}
interface TestimonialsProps {
  title?: string;
  testimonials: Testimonial[];
}
export function Testimonials({
  title,
  testimonials
}: TestimonialsProps) {
  return <section className="py-20 bg-dark relative" data-id="element-255">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-256">
        {title && <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-257">
            <h2 className="text-2xl md:text-3xl font-display font-bold text-white flex items-center justify-center gap-2" data-id="element-258">
              <span className="text-red-500" data-id="element-259">❤️</span> {title}
            </h2>
          </motion.div>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-260">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: i * 0.1
        }} className="glass-card p-6 rounded-2xl relative overflow-hidden group hover:border-cyan-500/30 transition-colors" data-id="element-261">
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-cyan-400 to-purple-500 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-262"></div>
              <div className="flex items-center gap-4 mb-4" data-id="element-263">
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center font-bold text-cyan-400 border border-white/5" data-id="element-264">
                  {t.initials}
                </div>
                <div data-id="element-265">
                  <h4 className="font-bold text-white" data-id="element-266">{t.name}</h4>
                  <p className="text-xs text-gray-400" data-id="element-267">{t.location}</p>
                </div>
              </div>
              <p className="text-gray-300 italic text-sm leading-relaxed" data-id="element-268">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}